/**
 * Feature flags — code-level switches for features that ship dark or need a
 * quick kill switch. Flip the boolean, rebuild, deploy. Keep every flag
 * documented with what it gates and where it is read.
 *
 * Reading a flag anywhere else in the app must go through `isFeatureEnabled`
 * so a flag can later be moved to a remote source (e.g. `niv_settings`)
 * without touching call sites.
 */

export const FEATURE_FLAGS = {
  /**
   * Interactive "pending actions" walkthrough on the home page: a sample
   * meeting the therapist updates end-to-end (happened → report → payment →
   * reminder) with zero Firestore writes. Read in
   * `components/dashboard/CollapsibleSections.js`.
   */
  PENDING_ACTIONS_DEMO: true,
};

export const isFeatureEnabled = (flag) => FEATURE_FLAGS[flag] === true;
